import type { NavLinkProps } from '@remix-run/react'
import { Link, NavLink, useNavigation } from '@remix-run/react'
import { useSetAtom } from 'jotai'
import { useEffect } from 'react'
import { cn } from '~/styles/utils'
import { Button, buttonVariants } from '../ui/button'
import { Icon } from '../ui/icon'
import { ScrollArea } from '../ui/scroll-area'
import { sidebarOpenAtom } from './layout'

interface SidebarProps extends React.HTMLAttributes<HTMLDivElement> {}

export function Sidebar({ className }: SidebarProps) {
  const navigation = useNavigation()
  const setOpenSidebar = useSetAtom(sidebarOpenAtom)

  const navlinkClassName: NavLinkProps['className'] = ({
    isActive,
    isPending,
    isTransitioning,
  }) => {
    return cn(
      buttonVariants({
        variant: isActive ? 'secondary' : 'ghost',
        size: 'default',
        className: '',
      }),
      'w-full justify-start rounded',
      isActive
        ? 'bg-sky-200 hover:bg-sky-600 hover:text-sky-100 text-sky-900'
        : '',
      '[&[data-disabled]]:opacity-40',
    )
  }

  useEffect(() => {
    if (navigation.state != 'idle') {
      setOpenSidebar(false)
    }
  }, [navigation.state, setOpenSidebar])

  return (
    <ScrollArea className={cn('pb-4', className)}>
      <div className="space-y-4 py-4">
        <div className="px-3 py-2">
          <h2 className="mb-2 px-4 text-lg font-semibold tracking-tight">
            Prim Sistemi
          </h2>
          <div className="space-y-1">
            <NavLink to="/" className={navlinkClassName}>
              <Icon name="lucide:calendar-check" className="mr-2 size-4" />
              Güncel Dönem
            </NavLink>
            <NavLink to="/bloke-prim" className={navlinkClassName}>
              <Icon name="lucide:captions-off" className="mr-2 size-4" />
              Cari Bakiye Blokeli Primler
            </NavLink>
            <NavLink to="/donem-list" className={navlinkClassName}>
              <Icon name="lucide:layout-list" className="mr-2 size-4" />
              Geçmiş Dönemler
            </NavLink>
            <NavLink to="/donem-duzenle" className={navlinkClassName}>
              <Icon name="lucide:settings" className="mr-2 size-4" />
              Ayarlar
            </NavLink>
            <div className="border border-orange-500 p-2 bg-orange-50">
              <div className="text-orange-700 text-0 mb-4">
                Geçiçi müdehale alanı
                <br />
                <br />
                aşağıdaki dönemlere tıkladığınızda tüm sistem o döneme göre
                sıfırlanır.
              </div>
              <div>
                <Link to="/tmp-donem-gecis/1" className="text-orange-700 mr-2">
                  2024-10
                </Link>
                <Link to="/tmp-donem-gecis/2" className="text-orange-700 mr-2">
                  2024-11
                </Link>
                <Link to="/tmp-donem-gecis/3" className="text-orange-700 mr-2">
                  2024-12
                </Link>
              </div>
              <div className="text-orange-700 text-0 mt-4">
                islem biraz zaman alabilir. lutfen ekranda bekleyiniz.
              </div>
            </div>
          </div>
        </div>
      </div>
    </ScrollArea>
  )
}
